import { render, staticRenderFns } from "./TaxPayerInput.vue?vue&type=template&id=3969d562&"
import script from "./TaxPayerInput.vue?vue&type=script&lang=js&"
export * from "./TaxPayerInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports